function SearchAutocomplete() {
}

SearchAutocomplete.fn = {
    init: function () {
        SearchAutocomplete.fn.search.call(this);
    },

    search: function () {
        function search() {
            // Add small delay to make the keyup element smoother
            var keyUpTimer = null;
            $('.search-autocomplete').on('keyup', function () {
                if (keyUpTimer) {
                    clearTimeout(keyUpTimer);
                }

                var element = $(this);

                keyUpTimer = setTimeout(function () {
                    findProducts(element);
                }, 1000);
            });
            $('.search-autocomplete').on('focus', function () {
                var elm = $(this).closest('form').find(".search-result");
                if (elm.find('.suggest_search').length) {
                    elm.show();
                } else {
                    if (keyUpTimer) {
                        clearTimeout(keyUpTimer);
                    }

                    var element = $(this);

                    keyUpTimer = setTimeout(function () {
                        findProducts(element);
                    }, 600);
                }
            });
        }

        function findProducts(element) {
            var elem = $(element);

            $.ajax({
                url: elem.data('action'),
                type: "post",
                dataType: "json",
                data: elem.serialize(),
                success: function (response) {
                    if (response.success && response.success != "") {
                        elem.closest('form').find(".search-result").show().html(response.data);
                    } else {
                        elem.closest('form').find(".search-result").hide();
                    }
                }
            });
        }

        $(document).click(function (n) {
            var t = $(".search-autocomplete");
            t.is(n.target) || t.has(n.target).length !== 0 || $(".search-result").hide();
        });

        search();
    },

    rule: function () {
        $(document).ready(function () {
            SearchAutocomplete.fn.init.call(this);
        });
    },
};

SearchAutocomplete.fn.rule();
